import Axios from 'axios'
import store from '../store'

const equipment = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getEquipments () {
    return Axios.get('api/internal/equipments')
  },
  getEquipmentsByClient () {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/equipments')
  },
  saveEquipmentsByClient (avaliableEquipments) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/equipments', avaliableEquipments)
  },
  createEquipment (equipment) {
    return Axios.post('api/internal/equipments', equipment)
  },
  editEquipment (equipment) {
    return Axios.put('api/internal/equipments/' + equipment.id, equipment)
  },
  deleteEquipment (equipment) {
    return Axios.delete('api/internal/equipments/' + equipment.id)
  },
  forceSync () {
    return Axios.put(`api/internal/clients/${this.getClientId()}/places/sync`)
  }
}

export default equipment
